import React from 'react'
import { Col, Container, Row } from 'reactstrap'

import PartnerService from '../services/PartnerService';
import { useQuery } from '@tanstack/react-query';
import { imageBaseApi } from '../services/imageBaseApi';

const Professional2 = ({about=true, aboutPartner=false}) => {

const borderColor = '#dee2e6';

const fetchData= async ()=>{
  const response = await PartnerService.getList();
  return response;
}

const {isPending,error, data: partnerData} = useQuery({
  queryKey: ['partnerData'],
  queryFn: fetchData,
})


  return (
    <div className='main-container' style={{marginBottom:"156px"}}>
      <Container fluid className=''>

      
      {about&&(  <Row className='justify-content-start'>
          <Col xs={12} lg={10} className='text-start p-0'>
            <h1 className="font-level-4 mb-3 lh-1 vw-100 ">
              PROFESSIONAL CERTIFICATION <br /> & PARTNERSHIPS
            </h1>
          </Col>
        </Row>)}

         {partnerData?.sort((a, b) => a.orderIndex - b.orderIndex)
  .map((category) => (
    <React.Fragment key={category.id}>
      {/* Category Title */}
      <Row className='justify-content-start mb-3'>
        <Col xs={12} lg={10} className='text-start p-0'>
          <p 
            className={`text-muted mb-3 ${!aboutPartner ? "mt-4" : ""}`}
            style={{ 
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              fontWeight: '500' 
            }}
          >
            {category.name}:
          </p>
        </Col>
      </Row>

      {/* Partners Grid */}
      <Row 
        className="justify-content-start about-map"
        style={{ 
         
          borderLeft: `1px solid ${borderColor}`,
        }}
      >
        {category.partnerDetails
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .map((partner) => (
            <Col
              key={partner.id}
              xs={6}
              sm={6}
              md={4}
              lg={3}
              className="d-flex justify-content-start px-2 px-md-3 align-items-center"
              style={{
                 borderTop: `1px solid ${borderColor}`, 
                borderRight: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
              }}
            >
              <img 
                src={imageBaseApi+partner.media.url} 
                alt={partner.name} 
                className="img-fluid" 
              />
            </Col>
          ))}
      </Row>
    </React.Fragment>
  ))}

       
      
        
      </Container>
    </div>
  )
}

export default Professional2